import { render, staticRenderFns } from "./ConnectSocialAccount.vue?vue&type=template&id=9ddbbf2a&"
import script from "./ConnectSocialAccount.vue?vue&type=script&lang=js&"
export * from "./ConnectSocialAccount.vue?vue&type=script&lang=js&"
import style0 from "./ConnectSocialAccount.vue?vue&type=style&index=0&lang=scss&scopped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports